__turbopack_context__.v({
  "container": "GallerySliderBlock-module__6Kkyca__container",
  "fadeInItems": "GallerySliderBlock-module__6Kkyca__fadeInItems",
  "media": "GallerySliderBlock-module__6Kkyca__media",
  "slider": "GallerySliderBlock-module__6Kkyca__slider",
  "spacing--lg": "GallerySliderBlock-module__6Kkyca__spacing--lg",
  "spacing--md": "GallerySliderBlock-module__6Kkyca__spacing--md",
  "spacing--sm": "GallerySliderBlock-module__6Kkyca__spacing--sm",
  "spacing--xl": "GallerySliderBlock-module__6Kkyca__spacing--xl",
  "spacing--xs": "GallerySliderBlock-module__6Kkyca__spacing--xs",
  "spacing--xxl": "GallerySliderBlock-module__6Kkyca__spacing--xxl",
  "spacing--xxs": "GallerySliderBlock-module__6Kkyca__spacing--xxs",
  "spacing--xxxl": "GallerySliderBlock-module__6Kkyca__spacing--xxxl",
  "spacing--xxxs": "GallerySliderBlock-module__6Kkyca__spacing--xxxs",
});
